import * as React from "react";
import { postFormAsync, postAsync } from "../utils/net";
import { Button } from "reactstrap";
import UploadFileDialog from "./upload-file";
import i18n from "../i18n";
import { Environment } from "../models/environment";
import { ModalNotification } from "../utils/modalNotification";

export interface QnaReleaseProps {
    environments: Environment[]
    channels: string[]
}
export interface QnaReleaseState {
    targetEnvironments: Environment[],
    currentTarget: Environment,
    sourceEnvironmentsNames: string[],
    currentSourceName: string,
    showUploadDialog: boolean,
    targetEnvironmentSelected: boolean,
    targetChannelSelected: boolean,
    currentChannelTarget: string,
    targetChannels: string[],
    showModal: boolean;
    modalMessage: string;
    modalResolve?: () => void;
}

const uploadFromLocalLabel = "Manual Upload";

export class QnaRelease extends React.Component<
    QnaReleaseProps,
    QnaReleaseState
    > {

    constructor(props: QnaReleaseProps) {
        super(props);

        this.onEnvironmentTargetChange = this.onEnvironmentTargetChange.bind(this);
        this.onEnvironmentSourceChange = this.onEnvironmentSourceChange.bind(this);
        this.onChannelTargetChange = this.onChannelTargetChange.bind(this);

        var targetEnvironments = this.props.environments.filter(t => this.getSourceEnvironmentsNames(t).length > 0);
        var targetChannels = this.props.channels;

        if (targetEnvironments.length > 0 && targetChannels.length > 0) {
            var currentTarget = targetEnvironments[0];
            var currentChannelTarget = targetChannels[0];

            var sourceEnvironmentsNames = this.getSourceEnvironmentsNames(currentTarget);

            this.state = {
                targetEnvironments: targetEnvironments,
                currentTarget: currentTarget,
                sourceEnvironmentsNames: sourceEnvironmentsNames,
                currentSourceName: sourceEnvironmentsNames[0],
                showUploadDialog: false,
                targetEnvironmentSelected: false,
                targetChannelSelected: false,
                targetChannels: targetChannels,
                currentChannelTarget: currentChannelTarget,
                showModal: false,
                modalMessage: ""
            };

            this.showModal = this.showModal.bind(this);
            this.hideModal = this.hideModal.bind(this);
        }
    }

    private showModal(message: string): Promise<void> {
        return new Promise((resolve) => {
            this.setState({ showModal: true, modalMessage: message, modalResolve: resolve });
        });
    }

    private hideModal() {
        this.setState({ showModal: false, modalMessage: "" }, () => {
            if (this.state.modalResolve) {
                this.state.modalResolve();
                this.setState({ modalResolve: undefined });
            }
        });
    }

    render() {

        if (!this.state) {
            return (
                <form>
                    <h1>{i18n.Release.Qna.Title}</h1>
                    <br />
                    <div>{i18n.Release.Qna.NoQnaAvailable}</div>
                </form>
            );
        }

        return (
            <form>
                <h1>{i18n.Release.Qna.Title}</h1>
                <br />
                <div>{i18n.Release.Qna.MainText}</div>
                <br />
                <div className="form-group">
                    <label>{i18n.Release.Qna.TargetChannel}</label>
                    <select
                        className="form-control"
                        onChange={this.onChannelTargetChange}
                        value={this.state.targetChannelSelected ? this.state.currentChannelTarget : ""}
                    >
                        <option value="" disabled={true}>{i18n.Release.Qna.SelectChannel}</option>
                        {this.state.targetChannels.map(s =>
                            <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
                <div className="form-group">
                    <label>{i18n.Release.Qna.TargetLabel}</label>
                    <select
                        className="form-control"
                        onChange={this.onEnvironmentTargetChange}
                        value={this.state.targetEnvironmentSelected ? this.state.currentTarget.name : ""}
                    >
                        <option value="" disabled={true}>{i18n.Release.Qna.SelectEnvironment}</option>
                        {this.state.targetEnvironments.map(o =>
                            <option key={o.name} value={o.name}>{o.name}</option>)}
                    </select>
                </div>

                {(this.state.targetEnvironmentSelected) && (<div className="form-group">
                    <label>{i18n.Release.Qna.SourceLabel}</label>
                    <select className="form-control" onChange={this.onEnvironmentSourceChange}>
                        {this.state.sourceEnvironmentsNames.map(source =>
                            <option key={source} value={source}>
                                {source === uploadFromLocalLabel ?
                                    uploadFromLocalLabel : i18n.Release.Qna.ImportFrom + " " + source}
                            </option>)}
                    </select>
                    <br />
                    {(this.state.currentSourceName === uploadFromLocalLabel) &&
                        (<h6>{i18n.Release.Qna.FileFormat}</h6>)}
                </div>)}

                <div>
                    {(this.state.targetEnvironmentSelected) &&
                        (this.state.currentSourceName === uploadFromLocalLabel) &&
                        (this.state.targetChannelSelected) &&
                        (<Button color="primary" onClick={() => this.showUploadFileDialog(true)}>Upload</Button>)}

                    {(this.state.targetEnvironmentSelected) &&
                        (this.state.targetChannelSelected) &&
                        (this.state.currentSourceName !== uploadFromLocalLabel) && (
                            <Button
                                color="primary"
                                onClick={() =>
                                    this.releaseQnaKb(this.state.currentSourceName,
                                        this.state.currentTarget.name, this.state.currentChannelTarget)}
                            >
                                Release
                            </Button>
                        )
                    }
                </div>
                <UploadFileDialog
                    isOpen={this.state.showUploadDialog}
                    onCancel={() => this.showUploadFileDialog(false)}
                    onUpload={(file) => this.uploadQnaKb(file,
                        this.state.currentTarget.name, this.state.currentChannelTarget)}
                />
                <ModalNotification
                    modalMessage={this.state.modalMessage}
                    showModal={this.state.showModal}
                    onClose={this.hideModal}
                />
            </form>
        );
    }

    private showUploadFileDialog(show: boolean) {
        this.setState({ showUploadDialog: show })
    }

    private getSourceEnvironmentsNames(targetEnvironment: Environment) {

        var sourceEnvironmentsNames = this.props.environments.
            filter(s => s.nextEnvironment === targetEnvironment.name).map(s => s.name);

        if (!targetEnvironment.isRestricted) {
            sourceEnvironmentsNames.unshift(uploadFromLocalLabel);
        }

        return sourceEnvironmentsNames;

    }

    private onEnvironmentTargetChange(event: React.ChangeEvent<HTMLSelectElement>) {

        const target = this.state.targetEnvironments.find(e => e.name === event.target.value);

        if (target) {

            var sourceEnvironmentsNames = this.getSourceEnvironmentsNames(target);

            this.setState({
                currentTarget: target,
                sourceEnvironmentsNames: sourceEnvironmentsNames,
                currentSourceName: sourceEnvironmentsNames[0],
                targetEnvironmentSelected: true
            });
        }
    }

    private onChannelTargetChange(event: React.ChangeEvent<HTMLSelectElement>) {
        const target = this.state.targetChannels.find(e => e === event.target.value);
        if (target) {
            this.setState({
                currentChannelTarget: target,
                targetChannelSelected: true
            });
        }
    }

    private onEnvironmentSourceChange(event: React.ChangeEvent<HTMLSelectElement>) {

        this.setState({
            currentSourceName: event.target.value
        });
    }

    private async uploadQnaKb(file: File, targetEnvironmentName: string, targetChannelName: string) {
        this.setState({ showUploadDialog: false });

        const formData = new FormData();
        formData.append("file", file);
        formData.append("targetEnvironmentName", targetEnvironmentName);
        formData.append("targetChannelName", targetChannelName);
        const result = await postFormAsync("/api/ReleaseManagement/qna/upload", formData);
        if (result.ok) {
            await this.showModal(i18n.Release.Qna.UploadOk);
        }
    }

    private async releaseQnaKb
        (sourceEnvironmentName: string, targetEnvironmentName: string, targetChannelName: string) {
        const message = "Do you want to publish " + sourceEnvironmentName + " KB on " + targetEnvironmentName
            + " for channel " + targetChannelName + "?"
        if (!confirm(message)) {
            return;
        }

        const body = {
            source: sourceEnvironmentName,
            target: targetEnvironmentName,
            channel: targetChannelName
        };
        const result = await postAsync("/api/ReleaseManagement/qna/release", body);
        this.setState({ showUploadDialog: false });
        if (result.ok) {
            await this.showModal(i18n.Release.Qna.PublishOk);
        }
    }
}


// WEBPACK FOOTER //
// ./src/release-management/qna-release.tsx